import { userConstants } from './constantData';

const bannerDimensions = [
  ...userConstants,
  'v_tab',
  'v_banner_title',
];

export const HOME_DATA = {
  home: {
    page_view: {
      hash: 'p-002.001.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
  },
  banner: {
    page_view: {
      hash: 'p-002.205.000.000.000.000',
      event: 'pages',
      dimensions: [...bannerDimensions],
    },
    banner_click: {
      hash: 'e-002.205.001.000.000.101',
      event: 'interactions',
      dimensions: [...bannerDimensions],
    },
  },
  dialog_banner: {
    page_view: {
      hash: 'p-002.206.000.000.000.000',
      event: 'pages',
      dimensions: [...bannerDimensions],
    },
    banner_click: {
      hash: 'e-002.206.001.000.000.101',
      event: 'interactions',
      dimensions: [...bannerDimensions],
    },
  },
};
